import * as React from 'react';

import * as styles from './index.css';

interface IAboutProps {
  title: string;
  content: string;
}

export class About extends React.Component<IAboutProps, object> {
  public render() {
    const { title, content } = this.props;

    return (
      <div className={styles['container']}>
        <h3 className={styles['builder']}>{title}</h3>
        {/* eslint-disable-next-line react/no-danger */}
        <div className={styles['description']} dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    );
  }
}
